export default "__VITE_PUBLIC_ASSET__526c2868__"